import FaqItem from './FaqItem';
import {faqList} from '../../../content/faqList';
import * as Styled from './FaqStyles';
import Headline from '../Headline/Headline';

const Faq = () => {
  return (
    <Styled.Container className="FaqWrapper" id='faqs'>
      <Headline tag="h1">Frequently Asked Questions</Headline>
      <Styled.Container>
        {
          faqList.map( (e, i) => (
            <FaqItem
              icon={e.pathname}
              header={e.header}
              subItems={e.subItems}
              key={`${e.header}-${i}`}
            />
          ))
        }
      </Styled.Container>
    </Styled.Container>
  );
}

export default Faq;